import { queryOptions } from '@tanstack/react-query';

import { api } from '@lib/api/client';
import type {
  CheckoutDataResponse,
  ShippingMethodsResponse,
} from '@marxbiotech/shared-types/bff';

// =============================================================================
// Query Keys
// =============================================================================

export const checkoutKeys = {
  all: ['checkout'] as const,
  data: () => [...checkoutKeys.all, 'data'] as const,
  shippingMethods: () => [...checkoutKeys.all, 'shippingMethods'] as const,
};

// =============================================================================
// Query Options
// =============================================================================

/**
 * Query options for fetching checkout data.
 * Combines cart, customer, addresses, payment info, and enabled payment providers.
 * staleTime: 0 - Always refetch for checkout flow to ensure data freshness.
 */
export const checkoutDataQueryOptions = () =>
  queryOptions({
    queryKey: checkoutKeys.data(),
    queryFn: async () => {
      const response = await api.get<CheckoutDataResponse>('/checkout/data');
      return response.data;
    },
    staleTime: 0, // Always refetch for checkout flow
  });

/**
 * Query options for fetching available shipping methods for the current cart.
 * staleTime: 30 seconds - Shipping options don't change frequently.
 */
export const shippingMethodsQueryOptions = () =>
  queryOptions({
    queryKey: checkoutKeys.shippingMethods(),
    queryFn: async () => {
      const response = await api.get<ShippingMethodsResponse>(
        '/carts/current/shipping-methods'
      );
      return response.data.shipping_options;
    },
    staleTime: 30 * 1000, // 30 seconds
  });
